module.exports = __webpack_public_path__ + "static/img/Kiitoskortti_Avecor_jarkko-tunturi_A4.ac51ce2.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/salesperson-leaflets/Kiitoskortti_Avecor_jarkko-tunturi_A4.pdf
// module id = bgdT
// module chunks = 22